export default __webpack_public_path__ + "static/media/skyvssea-overview.8d86a07e.gif";